<template>
    <div class="floor">
        <!-- 楼层标题 -->
        <div class="floor_title">
            <div class="floor_title_content">
                <span class="floor_title_border"></span>
                <span class="floor_title_content_index">{{ floorConfig.index || "2F" }}</span>
                <span class="floor_title_content_text">{{ floorConfig.title || "NiuShop" }}</span>
            </div>

            <!-- 右侧分类链接区 -->
            <div class="other-title" v-if="floorConfig.titleLink">
                <router-link :to="floorConfig.titleLink.url">{{ floorConfig.titleLink.content }} <i class="iconfont iconarrow-right"></i></router-link>
            </div>
        </div>
        <!-- 楼层内容区 -->
        <div class="floor-content">
            <div class="floor-right">
                <div class="floor-right-top">
                    <div
                        class="top-first"
                        @click="handleLinkClick(floorConfig.left_top_left_images.url)"
                    >
                        <el-image
                            v-if="floorConfig.left_top_left_images.image"
                            :src="$img(floorConfig.left_top_left_images.image)"
                            fit="cover"
                        />
                    </div>
                    <div
                        class="top-second"
                        @click="handleLinkClick(floorConfig.left_top_right_images.url)"
                    >
                        <el-image
                            v-if="floorConfig.left_top_right_images.image"
                            :src="$img(floorConfig.left_top_right_images.image)"
                            fit="cover"
                        />
                    </div>
                </div>
                <div class="floor-right-bottom">
                    <div
                        class="bottom-first"
                        @click="handleLinkClick(floorConfig.left_bottom_left_images.url)"
                    >
                        <el-image
                            v-if="floorConfig.left_bottom_left_images.image"
                            :src="$img(floorConfig.left_bottom_left_images.image)"
                            fit="cover"
                        />
                    </div>
                    <div
                        class="bottom-second"
                        @click="handleLinkClick(floorConfig.left_bottom_right_images.url)"
                    >
                        <el-image
                            v-if="floorConfig.left_bottom_right_images.image"
                            :src="$img(floorConfig.left_bottom_right_images.image)"
                            fit="cover"
                        />
                    </div>
                </div>
            </div>
            <div class="floor-left">
                <cargo-item :cargo="item" v-for="(item, index) in skuList" :key="index" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import CargoNormal from "@/components/cargo/CargoNormal"
import { floorGoods, goodsSkuList } from "@/api/goods/goods"
import CargoItem from "./cargo_item_1"

export default {
    name: "style2",
    components: {
        CargoNormal,
        CargoItem
    },
    props: {
        config: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            display: "",
            floorConfig: {
                validated: false,
                rightCargos: [],
                left_top_left_images: {},
                left_top_right_images: {},
                left_bottom_left_images: {},
                left_bottom_right_images: {}
            },
			skuList: []
        }
    },
    created() {
        this.$store.dispatch("site/defaultFiles")
        this.getSkuList()
    },
    computed: {
        ...mapGetters(["defaultGoodsImage"])
    },
    methods: {
        handleCargoClick(skuId) {
            if (skuId) {
                this.$router.pushToTab(`/sku-${skuId}`)
            }
        },
        handleLinkClick(url) {
            if (url) {
                this.$router.pushToTab(`${url}`)
            }
        },
        getSkuList() {
            const sku_ids = this.floorConfig.rightCargos
                .map(item => {
                    return item.sku_id
                })
                .toString()

            goodsSkuList({ sku_ids })
                .then(res => {
                    this.skuList = res.data
                })
                .catch(err => {})
        }
    },
    watch: {
        config: {
            handler: function(curr) {
                if (curr && curr.rightCargos && curr.left_top_left_images && curr.left_top_right_images && curr.left_bottom_left_images && curr.left_bottom_right_images) {
                    this.floorConfig = { ...curr, validated: true }
                }
            },
            immediate: true,
            deep: true
        }
    }
}
</script>
</script>

<style lang="scss" scoped>
.floor {

    &_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;
        &_border {
            display: inline-block;
            width: 5px;
            height: 28px;
            background-color: $base-color;
            margin-right: 12px;
            vertical-align: top;
        }

        &_content {
            font-size: 20px;
            padding-top: 10px;
            padding-bottom: 10px;
            height: 48px;
            line-height: 28px;
            // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
			box-sizing: border-box;

            &_index {
                display: inline-block;
                color: $ns-text-color-black;
                padding-right: 8px;
                font-weight: 600;
            }

            &_text {
				font-weight: 600;
				display: inline-block;
                color: $base-color;
            }
        }
        .other-title {
            a {
                color: #838383;

                i {
                    font-size: 14px;
                }
				
				&:hover {
					color: $base-color;
				}
            }
        }
    }

    .el-image {
        width: 100%;
        height: 100%;
        z-index: 100;
    }
    .floor-content {
        display: flex;
		width: 100%;
		height: 500px;
        .floor-right {
			width: 50%;
			cursor: pointer;
            .floor-right-top {
				height: 62%;
                display: flex;
                .top-first {
                    width: 35%;
                    height: 100%;
                    overflow: hidden;
                }
                .top-second {
                    width: 65%;
                    height: 100%;
                    overflow: hidden;
                }
            }
            .floor-right-bottom {
				height: 38%;
                display: flex;
                .bottom-first {
                    width: 35%;
                    height: 100%;
                    overflow: hidden;
                }
                .bottom-second {
                    width: 65%;
                    height: 100%;
                    overflow: hidden;
                }
            }
        }
        .floor-left {
			width: 50%;
            display: flex;
            flex-wrap: wrap;
			justify-content: space-around;
			align-content: space-between;
            .floor-left-item {
                width: 33.3%;
                height: 50%;
				box-sizing: border-box;
				background-color: #FFFFFF;
				padding: 12px 10px;
                border: 1px solid #E9E9E9;
				border-top: none;
				border-left: none;
                cursor: pointer;
				
				&:nth-child(-n+3) {
					border-top: 1px solid #E9E9E9;
				}

                &:nth-child(3n + 1) {
                    border-left: 1px solid #e9e9e9;
                }
				
                .floor-left-title {
					width: 100%;
                    font-size: $ns-font-size-base;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
					margin-top: 5px;
                }
                .floor-left-sub-title {
                    font-size: $ns-font-size-sm;
                    color: $base-color;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .floor-left-img-wrap {
                    width: 100%;
                    height: 177px;
					.item_image {
						height: 100%;
					}
                }
            }
        }
    }
}
</style>
